import {DisplayState} from "../reducers/displayReducer";
import {ColumnKey} from "../constants/display-columns";

export const defaultLocations = ['FINISH']
const defaultColumns = [ColumnKey.Name, ColumnKey.RollName, ColumnKey.Score]
const defaultContentFontSize = 17
const defaultHeaderFontSize = 18

const getInitialSelectedColumns = (params: URLSearchParams): ColumnKey[] => {
    const selectedColumns: ColumnKey[] = params
        .getAll("selectedColumns")
        .filter((value): value is ColumnKey =>
            Object.values(ColumnKey).includes(value as ColumnKey)
        );

    if(selectedColumns.length) {
        return selectedColumns;
    }

    try {
        const columnsFromStorage = localStorage.getItem("caruz_selectedColumns");
        if(columnsFromStorage) {
            return JSON.parse(columnsFromStorage).filter((value: string): value is ColumnKey =>
                Object.values(ColumnKey).includes(value as ColumnKey)
            );
        }
    }
    catch (e) {
        return defaultColumns;
    }

    return defaultColumns;
}

export const getInitialDisplayState = () => {
    const params = new URLSearchParams(window.location.search);

    const selectedLocations = params.getAll('selectedLocations')
    const headerFontSize = params.get('headerFontSize') ?? localStorage.getItem('caruz_headerFontSize');
    const contentFontSize  = params.get('contentFontSize') ?? localStorage.getItem('caruz_contentFontSize');

    const initialDisplayReducerState: DisplayState = {
        Comp: null,
        SelectedLocations: selectedLocations.length > 0 ? selectedLocations : defaultLocations,
        SelectedColumns: getInitialSelectedColumns(params),
        ContentFontSize: contentFontSize ? +contentFontSize : defaultContentFontSize,
        HeaderFontSize: headerFontSize ? +headerFontSize : defaultHeaderFontSize,
        IncludeUnrecognizedChips: false
    }

    return initialDisplayReducerState;
};